import { action, createReducer } from 'shared/utils/redux'
const reducerHandler = createReducer()
function toQueryString(obj) {
  var parts = []
  for (var i in obj) {
    if (obj.hasOwnProperty(i) && obj[i]) {
      parts.push(encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]))
    }
  }
  return parts.join('&')
}

export const actions = {
  getProvinceList: action({
    type: 'recruitment.getProvinceList',
    action: (http) => {
      return http.get('/cms-web-api/area/bypid?pid=0')
    },
    handler: (state, result) => {
      return {
        ...state,
        provinceList: result.data
      }
    }
  }, reducerHandler),
  getCityList: action({
    type: 'recruitment.getCityList',
    action: (pid, http) => {
      return http.get(`/cms-web-api/area/bypid?pid=${pid}`)
    },
    handler: (state, result) => {
      return {
        ...state,
        cityList: result.data
      }
    }
  }, reducerHandler),
  getJobList: action({
    type: 'recruitment.getJobList',
    action: (params, http) => {
      const paramString = toQueryString(params)
      return http.get('/cms-web-api/cms/recruitment?' + paramString)
    },
    handler: (state, result) => {
      return {
        ...state,
        jobList: result.data.items,
        jobPagination: {
          currentPage: Number(result.data.page),
          total: Number(result.data.total),
          perPage: Number(result.data.pagesize)
        }
      }
    }
  }, reducerHandler),
  getJobDetail: action({
    type: 'recruitment.getJobDetail',
    action: (id, http) => {
      return http.get('/cms-web-api/cms/recruitment/' + id)
    },
    handler: (state, result) => {
      return {
        ...state,
        job: result.data
      }
    }
  }, reducerHandler)
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {

}

const initialState = {
  newsList: []
}

export function reducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  let nextState =  handler ? handler(state, action) : {...state}
  nextState = reducerHandler(initialState)(nextState, action)
  return nextState
}



// WEBPACK FOOTER //
// ./modules/recruitment/redux.js